import React from "react";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type VerticalDividerProps = BoxProps;

const VerticalDivider: React.FC<VerticalDividerProps> = props => {
    const { sx, ...otherProps } = props;

    return (
        <Box
            sx={{
                width: "2px",
                backgroundColor: "var(--proda-white-130)",
                mx: "8px",
                height: "25px",
                ...sx,
            }}
            {...otherProps}
        />
    );
};

export default VerticalDivider;
